import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import InputWrapper from '../../common/InputWrapper';
import { fetchGetProviders } from '../../../actions/settings';
import { useDispatch, useSelector } from 'react-redux';
import FranchiseItem from './FranchiseItem';

const Wrapper = styled('div')`
  min-height: 200px;
  .promocode-item {
    .promocode-name {
      font-weight: 600;
      cursor: pointer;
      .promocode-edit {
        visibility: hidden;
        margin-left: 10px;
        font-size: 16px;
        color: #98a6ad;
      }
    }

    .promocode-remove {
      display: none;
      cursor: pointer;
    }

    .badge {
      font-size: 12px;
      font-weight: 600;
    }

    &:hover {
      .promocode-edit {
        visibility: initial;
      }
      .promocode-remove {
        display: initial;
      }
    }
  }

  @media (max-width: 800px) {
    padding: 0 !important;
  }
`;

const FranchiseBlock = () => {
  const [search, setSearch] = useState('');
  const providers = useSelector((state) => state.settings.providers);
  const warehouses = useSelector((state) => state.orders.warehouses);
  const isOfertaAccepted = useSelector((state) => state.auth.account.ofertaAccepted);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGetProviders());
  }, []);

  return (
    <>
      {isOfertaAccepted && (
        <>
          <div className="border-bottom">
            <h4 className="header-title">Провайдеры услуг</h4>
          </div>
          {/*          <div className="row promocodes-row" style={{ marginTop: '16px' }}>
            <div className="col-lg-4">
              <InputWrapper
                noLabel
                id="promocodeSearch"
                placeholder="Поиск: провайдер, услуги"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>*/}
          <Wrapper className="fixed-table-container">
            <div className="table-responsive">
              <table className="table table-centered table-hover">
                <thead className="thead-light">
                  <tr>
                    <th colSpan="2">Провайдер</th>
                    <th>
                      <span style={{ paddingLeft: '20px' }}>Услуги</span>
                    </th>
                    <th>Город/склад</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {providers.length !== 0 &&
                    providers.map((item) => (
                      <FranchiseItem
                        name={item.name}
                        description={item.description}
                        logoUrl={item.logoUrl}
                        type={item.type}
                        warehouseFulfillmentSubType={item.warehouseFulfillmentSubType}
                        warehouseFulfillmentType={item.warehouseFulfillmentType}
                        email={item.email}
                        cityOfWarehouse={item.cityOfWarehouse}
                        warehouses={warehouses}
                      />
                    ))}
                </tbody>
              </table>
            </div>
          </Wrapper>
        </>
      )}
    </>
  );
};

export default FranchiseBlock;
